import Vue from 'vue';
import App from './App';
import { Popup, Button, Field,Toast,Area,Skeleton  } from "vant";
import { router } from './router';
import config from './config';
import Storage from "./utils/storageUtils";
import 'amfe-flexible'   // px转rem 
// 全局注册组件
Vue.use(Popup)
Vue.use(Button)
Vue.use(Field)
Vue.use(Area)
Vue.use(Toast)
Vue.use(Skeleton)
const CONSOLE_STYLE = {
  left: 'border-top-left-radius:4px;border-bottom-left-radius:4px;background-color:#1e2639;color:#fff;line-height:18px;padding-left:5px;padding-right:4px',
  right: 'border-top-right-radius:4px;border-bottom-right-radius:4px;background-color:#35B558;color:#fff;line-height:18px;padding-right:5px;padding-left:4px',
}

// 输出环境与打包时间
console.log(
  `%cEnvironment%c${config.env.toUpperCase()}`,
  CONSOLE_STYLE.left, CONSOLE_STYLE.right
)
if (config.buildDate) {
  console.log(`%cBuild Date%c${config.buildDate}`,
    CONSOLE_STYLE.left, CONSOLE_STYLE.right)
}

// 将配置挂载到Vue原型上，方便组件中使用
Vue.prototype.$config = config
// 挂载格式化工具
import format from './utils/format'
Vue.prototype.$format = format
Vue.prototype.$cache=Storage
new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
